import React, { useEffect, useState } from "react";
import Photo from "./Photo";

const Photocontainer = (props) => {
  const [pixToLoad, setPixToLoad] = useState([]);
  var isScrollable = true;

  useEffect(() => {
    setPixToLoad([]);
    
  }, [props.Pic]);

  useEffect(() => {  
    if (pixToLoad.length < props.Pic.length) {
      let photoLength =
        pixToLoad.length + 12 <= props.Pic.length
          ? pixToLoad.length + 12
          : props.Pic.length;
      let tempArr = [];
      for (var i = 0; i < photoLength; i++) {
        tempArr.push(JSON.parse(JSON.stringify(props.Pic[i])));
      }
      setPixToLoad(tempArr);
    }
  
  }, [pixToLoad]);

  const handleScroll = (e) => {
    if (isScrollable) {
      if (e.target.scrollHeight - e.target.scrollTop <= e.target.offsetHeight) {
        isScrollable = false;
        if (pixToLoad.length < props.Pic.length) {
          let photoLength =
            pixToLoad.length + 12 <= props.Pic.length
              ? pixToLoad.length + 12
              : props.Pic.length;
          let tempArr = [];
          for (var i = pixToLoad.length; i < photoLength; i++) {
            tempArr.push(JSON.parse(JSON.stringify(props.Pic[i])));
          }
          setPixToLoad(pixToLoad.concat(tempArr));
          isScrollable = true;
        }
      }
    }
  };

  return (
    <>
      <div className="p2" style={{ height: "100%" }}>
        <div
          onScroll={handleScroll}
          className="templatesParent d-flex  scrollbar style-1"
        >
          <div className="column1">
            {pixToLoad.map((photos, index) => {
              return (
                index % 2 === 0 && (
                  <Photo
                    isUserImage={props.isUserImage}
                    key={index}
                    dataItem="item-1"
                    relativePath={photos.relativePath}
                    url={photos.previewURL}
                    id={photos.id}
                    picurl={photos.fullHDURL}
                    UploadedData = {props.Pic}
                    setUploadData ={props.setUploadData}
                    setIsDeleted={props.setIsDeleted}
                  />
                )
              );
            })}
          </div>
          <div className="column2">
            {pixToLoad.map((photos, index) => {
              return (
                index % 2 != 0 && (
                  <Photo
                    isUserImage={props.isUserImage}
                    key={index}
                    dataItem="item-1"
                    id={photos.id}
                    relativePath={photos.relativePath}
                    url={photos.previewURL}
                    picurl={photos.fullHDURL}
                    UploadedData = {props.Pic}
                    setUploadData ={props.setUploadData}
                    setIsDeleted={props.setIsDeleted}
                  />
                )
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
export default Photocontainer;
